// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import setFixedHeader from "@store/Framework/Store/Bunzl/Components/Header/Handlers/SetFixedHeader";
import { HeaderIsFixedParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";

export default () => {
    const dispatch = useAppDispatch();

    return (parameter: HeaderIsFixedParameter) => {
        dispatch(setFixedHeader(parameter));
    };
};
